import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-calendar-check-01',
  imports: [],
  templateUrl: './calendar-check-01.html',
  styleUrl: './calendar-check-01.scss',
})
export class CalendarCheck01 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
